import cn from "classnames";
import isEqual from "lodash/isEqual";
import Chip from "components/Chip";
import React, { Component } from "react";
import QueryManagerContext from "context/QueryManager/QueryManagerContext";

import styles from "./styles.module.scss";

export default class CoWorkingFilter extends Component {
  toggleCoworkingOnly = () => {
    const { update, values } = this.context;
    update({
      leaseTypes: isEqual(values.leaseTypes, ["license_agreement"])
        ? []
        : ["license_agreement"],
      page: 1,
    });
  };

  render() {
    const { values } = this.context;
    const coworkingOnly = isEqual(values.leaseTypes, ["license_agreement"]);
    return (
      <Chip
        data-se="coworking-filter-button"
        active
        onClick={this.toggleCoworkingOnly}
        className={cn(styles.chip, {
          [styles.chipSelected]: coworkingOnly,
        })}
      >
        <input
          type="checkbox"
          id="scales"
          name="scales"
          checked={coworkingOnly}
          readOnly
          aria-label="Coworking Only"
        />
        Coworking Only
      </Chip>
    );
  }
}

CoWorkingFilter.contextType = QueryManagerContext;
